// extracted by mini-css-extract-plugin
export default {"bbs_wrap":"MyPageBoard_bbs_wrap__nm8ce","bbs_table":"MyPageBoard_bbs_table__4-cxz"};